import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';

import { Popup } from '@shared/ui';

import cls from './CharterItem.module.css';
import { planFactHelper } from '../../../../../helpers/planFactHelper';
import { useEditCharter } from '../../../../../hooks/useEditCharter';
import { useShowBlock } from '../../../../../hooks/useShowBlock';
import { connectionActions } from '../../../../../store/reducers/connectionSlice/connectionSlice';
import { gantActions } from '../../../../../store/reducers/gantSlice/gantSlice';
import { positionSelector } from '../../../../../store/reducers/positionSlice/positionSlice';
import { ArrowBlock } from '../../../../UI/ArrowBlock/ArrowBlock';
import s from '../../../../UI/DateInput/DataInput.module.css';
import { DateInput } from '../../../../UI/DateInput/DateInput';
import { DayInput } from '../../../../UI/DayInput/DayInput';
import { PositionItem } from '../PositionItem/PositionItem';

export const CharterItem = ({ charter }) => {
    const { opensCharters } = useSelector((state) => state.gantReducer);

    const dispatch = useDispatch();
    const { resetCharter, crateCharter, increaseCharter, decreaseCharter, onDataPickerCharter } =
        useEditCharter(charter);

    const positions = useSelector(positionSelector.selectEntities);
    const { settings } = useSelector((state) => state.gantReducer);

    const [isShowPopup, setState] = useState(false);

    const onChangePopup = (state, e) => {
        e.stopPropagation();
        if (isPlanFact) {
            setState(state);
        }
    };

    const [charterForm, setCharterForm] = useState({
        date: charter.planned.start_date ? moment(charter.planned.start_date).format() : null,
        days: charter.planned.days_count ? charter.planned.days_count : '',
    });

    const pickerEndDate = charterForm.date
        ? moment(charterForm.date)
              .add(+charterForm.days - 1, 'days')
              .format('DD.MM.YYYY')
        : moment(Date.now()).format('DD.MM.YYYY');

    const isLabor = charter?.children.some((guid) => positions[guid].type === 'labor');
    const isShowPosition = isLabor || settings.isShowMHD;

    useEffect(() => {
        setCharterForm({
            date: charter.planned.start_date ? moment(charter.planned.start_date).format() : null,
            days: charter.planned.days_count ? charter.planned.days_count : '',
        });
    }, [charter]);

    const { isShow, onShow } = useShowBlock(`${charter?.guid}`, opensCharters, (updatedCharter) =>
        dispatch(gantActions.changeOpenCharters(updatedCharter))
    );

    const isNotNeedInitCharter = charter.children.some(
        (positionGuid) => positions[positionGuid].planned.start_date !== null
    );

    const onDateChange = (value) => {
        setCharterForm((prevState) => ({ ...charterForm, days: value }));
    };

    const onSubmit = () => {
        if (charterForm.days === '0' || !charterForm.days) {
            resetCharter(charter);
            return;
        }

        if (isNotNeedInitCharter) {
            const newEndDate = moment(charterForm.date).add(+charterForm.days - 1, 'days');
            const oldEndDate = moment(charter.planned.end_date);
            const isDecrease = newEndDate.isBefore(oldEndDate);
            const differenceInDays = Math.abs(oldEndDate.diff(newEndDate, 'days'));

            if (isDecrease) {
                decreaseCharter(charter, differenceInDays);
            } else {
                increaseCharter(charter, {
                    days: charterForm.days,
                    date: moment(charterForm.date).format(),
                });
            }
        } else {
            crateCharter(charter, charterForm);
        }
    };

    const onPaymentDateChangeCancel = () => {
        resetCharter(charter);
    };
    const onPaymentDateChange = ({ start, end }) => {
        const startDate = moment(start);
        const endDate = moment(end);
        const duration = moment.duration(endDate.diff(startDate));
        const days = `${Math.round(+duration.asDays())}`;

        if (!isNotNeedInitCharter) {
            crateCharter(charter, { days, date: moment(start).format() });
        } else {
            onDataPickerCharter(charter, { start, end, days });
        }
    };

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!charter.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    if (!charter || !isShowPosition) return null;

    const { isNotEqualDate, isNotEqualDays, isRedDate, isRedDays } = planFactHelper(
        charter.planned,
        charter.actual,
        isPlanFact
    );

    return (
        <div
            className={classNames(cls.wrapper)}
            onClick={() => {
                onShow();
                dispatch(connectionActions.endConnection());
            }}
        >
            <Popup
                isOpen={isShowPopup}
                contentText={i18next.t('CharterItem.return.Popup.text')}
                onHidePopup={() => setState(false)}
                type="alert"
            />
            <div className={classNames(cls.charterItem, { [cls.factWrapper]: isPlanFact })}>
                <div className={classNames(cls.numberBlock)}>{charter?.number}</div>
                <ArrowBlock isShow={isShow} />
                <div className={classNames(cls.title)}>{charter?.name}</div>
                <div className={classNames(cls.capacity)}>
                    <span>
                        {charter.quantity} {charter.unit}
                    </span>
                </div>
                <div className={classNames(cls.dateBlock)} onClick={(e) => onChangePopup(true, e)}>
                    {isPlanFact ? (
                        <>
                            {charter.planned.start_date ? (
                                <span className={classNames(cls.factDate)}>
                                    {moment(charter.planned.start_date).format('DD.MM.YYYY')}
                                </span>
                            ) : (
                                <div className={classNames(s.svgWrapper)}>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M16.25 5H3.25V17H16.25V5Z" stroke="#757575" />
                                        <path d="M7.25 3H5.25V7H7.25V3Z" stroke="#757575" />
                                        <path
                                            d="M16.5 8.75H3V9.25H16.5V8.75Z"
                                            stroke="#757575"
                                            strokeWidth="0.5"
                                        />
                                        <path d="M14.25 3H12.25V7H14.25V3Z" stroke="#757575" />
                                    </svg>
                                </div>
                            )}
                        </>
                    ) : (
                        <DateInput
                            key={Math.random()}
                            isRequired
                            date={charterForm.date}
                            parameterName="datePlan"
                            newCallbackNotSingle={onPaymentDateChange}
                            newCallbackNotSingleCancel={onPaymentDateChangeCancel}
                            classes={[cls.charterInput, cls.input]}
                            options={{
                                startDate: charterForm.date
                                    ? moment(charterForm.date).format('DD.MM.YYYY')
                                    : moment(Date.now()).format('DD.MM.YYYY'),
                                endDate: pickerEndDate,
                                autoUpdateInput: true,
                                singleDatePicker: false,
                                showDropdowns: true,
                                autoApply: false,
                            }}
                        />
                    )}

                    {isPlanFact && isNotEqualDate && (
                        <span className={classNames(cls.secondary, { [cls.fact]: isRedDate })}>
                            {moment(charter?.actual?.start_date).format('DD.MM.YYYY')}
                        </span>
                    )}
                </div>
                <div className={classNames(cls.daysBlock)} onClick={(e) => onChangePopup(true, e)}>
                    {isPlanFact ? (
                        <>
                            {charter.planned.days_count ? (
                                <span>{charter.planned.days_count}</span>
                            ) : (
                                <span style={{ color: '#ADB0B5' }}>0</span>
                            )}
                        </>
                    ) : (
                        <DayInput
                            classes={cls.charterInput}
                            value={charterForm.days}
                            onChange={onDateChange}
                            onSubmit={onSubmit}
                        />
                    )}

                    {isPlanFact && isNotEqualDays && (
                        <span className={classNames(cls.secondary, { [cls.fact]: isRedDays })}>
                            {charter?.actual?.days_count}
                        </span>
                    )}
                </div>
            </div>
            {isShow && (
                <div
                    className={classNames(cls.positionBlock)}
                    onClick={(event) => event.stopPropagation()}
                >
                    {charter?.children.map((positionGuid) => (
                        <PositionItem
                            key={positionGuid}
                            position={positions[positionGuid]}
                            parentNumber={charter?.number}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
